import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Textarea } from '../ui/Textarea';
import { Input } from '../ui/Input';
import { CheckboxGroup } from '../ui/CheckboxGroup';
import { MascotPanel } from '../ui/MascotPanel';
export function Step5Story() {
  const {
    data,
    updateData
  } = useIntake();
  const feelOptions = [{
    value: 'professional',
    label: 'Professioneel & Zakelijk'
  }, {
    value: 'modern',
    label: 'Modern & Innovatief'
  }, {
    value: 'luxury',
    label: 'Luxe & Premium'
  }, {
    value: 'approachable',
    label: 'Toegankelijk & Vriendelijk'
  }, {
    value: 'expert',
    label: 'Autoriteit & Expert'
  }, {
    value: 'playful',
    label: 'Speels & Creatief'
  }, {
    value: 'calm',
    label: 'Rustig & Betrouwbaar'
  }, {
    value: 'bold',
    label: 'Stoer & Opvallend'
  }, {
    value: 'other',
    label: 'Anders...'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-372">
      <MascotPanel message="Nu wordt het leuk! Vertel me meer over het DNA van uw bedrijf. Wat maakt u uniek? Deze input is cruciaal voor het design en de teksten." data-id="element-373" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-374">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-375">
          Bedrijfsverhaal & Positionering
        </h2>

        <Textarea label="Wat maakt u anders dan concurrenten?" infoTooltip="Denk aan uw Unique Selling Points (USP's). Waarom kiezen klanten voor u en niet voor de buurman?" placeholder="Bijv. Wij bieden 24/7 service, hebben 20 jaar ervaring, of gebruiken een unieke methode..." value={data.difference} onChange={e => updateData({
        difference: e.target.value
      })} data-id="element-376" />

        <Textarea label="Wat zijn uw kernwaarden?" placeholder="Bijv. Transparant, Duurzaam, Klantgericht, Snel..." value={data.coreValues} onChange={e => updateData({
        coreValues: e.target.value
      })} data-id="element-377" />

        <div data-id="element-378">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-379">
            Hoe moet het bedrijf aanvoelen voor een bezoeker?
            <span className="text-gray-400 font-normal ml-1" data-id="element-380">(max 3)</span>
          </label>
          <CheckboxGroup columns={2} options={feelOptions} values={data.companyFeel} onChange={vals => {
          if (vals.length <= 3) updateData({
            companyFeel: vals
          });
        }} data-id="element-381" />

          <AnimatePresence data-id="element-382">
            {data.companyFeel.includes('other') && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="mt-4 overflow-hidden" data-id="element-383">
                <Input placeholder="Vul hier in hoe het bedrijf moet aanvoelen..." value={data.companyFeelOther} onChange={e => updateData({
              companyFeelOther: e.target.value
            })} data-id="element-384" />
              </motion.div>}
          </AnimatePresence>
        </div>

        <Textarea label="Zijn er woorden of thema's die we absoluut moeten vermijden?" placeholder="Bijv. Gebruik het woord 'goedkoop' niet, wij zijn 'voordelig'." value={data.mustAvoid} onChange={e => updateData({
        mustAvoid: e.target.value
      })} data-id="element-385" />
      </div>
    </motion.div>;
}